import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';

import { ControlsModule } from 'app/controls/controls.module';
import { ImageSelectionDirectiveModule } from 'app/image-selection.directive';
import { ToolboxesModule } from 'app/toolboxes/toolboxes.module';
import { AdditionalInfoItemsComponent
       } from 'collage-designer/additional-info-items.component';
import { MatModule } from 'core/material/mat.module';
import { TranslationModule } from 'core/translation/translation.module';
import { ActionBarComponent
       } from './placeholder/action-bar/action-bar.component';
import { ActionBarDirective
       } from './placeholder/action-bar/action-bar.directive';
import { PlaceholderContentService
       } from './placeholder/placeholder-content.service';
import { PlaceholderService } from './placeholder/placeholder.service';
import { StageComponent } from './stage.component';
import { StageService } from './stage.service';
import { SVGValidationService } from './svg-validation.service';


@NgModule({
  imports: [
    CommonModule,
    ControlsModule,
    FormsModule,
    MatModule,
    ImageSelectionDirectiveModule,
    ToolboxesModule,
    TranslationModule,
  ],
  declarations: [
    ActionBarComponent,
    ActionBarDirective,
    StageComponent,
    AdditionalInfoItemsComponent,
  ],
  exports: [
    StageComponent,
  ],
  providers: [
    StageService, SVGValidationService, PlaceholderService,
    PlaceholderContentService
  ]
})
export class StageModule { }
